import React from "react";
import { Trans } from "app/utils";

const opactity = ["0.3", "0.4", "0.6", "0.9", "1"];

type EngagementSquaresProps = {
  squares: number;
};

const SocialEngagementSquares: React.FC<EngagementSquaresProps> = ({ squares }) => (
  <div className="EngagementRating">
    <div className="options clearfix">
      {[1, 2, 3, 4, 5].map(optionValue => (
        <div
          key={optionValue}
          className={`square ${squares >= optionValue ? "active" : "inactive"}`}
          style={squares >= optionValue ? { backgroundColor: `rgba(121, 177, 125, ${opactity[optionValue - 1]})` } : {}}
        />
      ))}
    </div>
  </div>
);

type SocialEngagementProps = {
  activity?: number;
};

const SocialEngagement: React.FC<SocialEngagementProps> = ({ activity }) => {
  const userActivity = activity ?? 0;

  if (userActivity < 40) {
    return (
      <div className="flx-row">
        <SocialEngagementSquares squares={1} />
        <span><Trans>Low</Trans></span>
      </div>
    );
  }

  if (userActivity >= 40 && userActivity < 75) {
    return (
      <div className="flx-row">
        <SocialEngagementSquares squares={3} />
        <span><Trans>Med</Trans></span>
      </div>
    );
  }

  return (
    <div className="flx-row">
      <SocialEngagementSquares squares={5} />
      <span><Trans>High</Trans></span>
    </div>
  );
};

export default SocialEngagement;
